<script lang="ts">
	import './diwologo.component.css';
	import { isDarkMode } from '../../../../stores/theme.store';
</script>

<a href="/" title="Decathlon Home Page">
	{#if $isDarkMode}
		<img class="diwoLogo_svg" alt="Decathlon MyGoogle" src="/logo_dark_mode.svg" />
	{:else}
		<img class="diwoLogo_svg" alt="Decathlon MyGoogle" src="/logo_light_mode.svg" />
	{/if}
</a>

<style src="./diwologo.component.css"></style>
